<div class="component-autofillButton">

    <label class="entry-label">
        předvyplnit vlastní účet
        <span
            class="fa fa-question-circle addedTooltip"
            *ngIf="concernedSubjects?.length > 0 && concernedBankAccounts?.length"
            title="Čísla účtů se předvyplňují z platebních údajů spravovaných osob ({{concernedSubjectsListString}})">
        </span>
    </label>

    <div *ngIf="concernedBankAccounts?.length">

        <button class="button-primary"
            *ngFor="let bankAccount of concernedBankAccounts | orderBy: ['bankName', 'name']"
            (click)="fillAccountDetails(bankAccount)"
            title="{{bankAccount.name}} – {{bankAccount.bankName}}"
            id="test-autofillButton">
                <span *ngIf="concernedSubjects?.length > 1">{{bankAccount.name}} –</span>
                {{bankAccount.bankName}}
        </button>

    </div>


    <p *ngIf="concernedSubjects?.length > 0 && !concernedBankAccounts?.length">
        Čísla účtů se předvyplňují z platebních údajů spravovaných osob.
        Přidejte si nový bankovní účet k osobě
        <span *ngFor="let concernedSubject of concernedSubjects; index as i">
            <span *ngIf="concernedSubjects.length > 1 && i > 0"> nebo </span>
            <a [routerLink]="['/subjects', 'show', concernedSubject.subject.id]"
                (click)="closeDialog()"
            >{{concernedSubject.name}}</a>
        </span>
        a bude se zde pak nabízet.
    </p>


</div>